import {
  fetchProjectInfo,
  GetProjectInfoQueryParams,
} from '@dc-shared-web/hooks/api/project/fetchProjectInfo'
import { PROJECTS_QUERY_KEY } from '@dc-shared-web/hooks/api/queryKeys'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useInfiniteQuery } from 'react-query'

export const useGetProjects = (params: GetProjectInfoQueryParams) => {
  const apiSvcCrunchesClient = useSvcCrunchesContext()

  return useInfiniteQuery({
    queryKey: [
      PROJECTS_QUERY_KEY,
      params?.teamUUID,
      params?.nameQuery,
      params?.folderUUID,
    ],
    queryFn: ({ pageParam = 1 }) => {
      return fetchProjectInfo(apiSvcCrunchesClient, {
        ...params,
        page: pageParam,
      })
    },
    getNextPageParam: (lastPage) => {
      return lastPage.totalpages > lastPage.page ? lastPage.page + 1 : undefined
    },
    enabled: params.enabled !== false && !!params.teamUUID,
  })
}
